import styled from 'styled-components/macro';
import Form from 'components/molecules/Form';

export const StyledForm = styled(Form)`
  text-align: left;
  max-width: 500px;
  margin: 0 auto;
`;
